export default "/_next/static/node_modules/@riot-private/blades-ui/dist/skins/league-client/assets/external-link.svg";